import React from 'react';

import { useTranslation } from 'react-i18next';

import { useJournalEventsFiltersContext } from '@features/JournalEventsFilters/lib/useJournalEventsFiltersContext';
import { TFilterItem } from '@features/JournalEventsFilters/model/types';
import { AuthorBadge } from '@features/JournalEventsFilters/ui/AuthorBadge';
import { Icon, UiMultiSelect } from '@shared/ui';

import cls from './FilterByAuthor.module.css';

export const FilterByAuthor = () => {
    const { authorsData, onAuthorClick, authorsDefaultValues, onClearAuthorsValues } =
        useJournalEventsFiltersContext();
    const { t } = useTranslation();

    return (
        <UiMultiSelect<TFilterItem>
            options={authorsData}
            defaultValues={authorsDefaultValues}
            placeholder={t('JournalEvents.Filters.Filter.byAuthor.placeholder')}
            leftIconSlot={<Icon iconName="taskAuthor" fill="#22B7D7" />}
            arrowIconSlot={<Icon iconName="selectArrow" />}
            clearIconSlot={<Icon iconName="resetInput" />}
            onItemClickCb={onAuthorClick}
            onClearValuesCb={onClearAuthorsValues}
            needSearch
            optionsListClassNames={cls.optionsList}
            badgeSlot={(option) => <AuthorBadge type={option.type} id={option.value} />}
        />
    );
};
